import React from 'react';
import { motion } from 'framer-motion';
import { ProductPanel } from '../ProductPanel';
import type { ClinicalNeed } from '../../types/filtek';
const ease = [0.16, 1, 0.3, 1] as const;

/** Need → technique → product, in that order, revealed only on selection. */
export function NeedDetail({
  need
}: {
  need: ClinicalNeed;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 28
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -18
  }} transition={{
    duration: 0.65,
    ease
  }} className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:gap-14" data-id="element-69" data-mp="2ail0kqlpjce2">
      <div data-id="element-70" data-mp="1mn04ys2m7cbf">
        <div className="relative overflow-hidden" data-id="element-71" data-mp="1mn8h2hqwydlk">
          <motion.img src={need.image} alt={`Clinical situation: ${need.label.toLowerCase()}`} className="h-56 w-full object-cover sm:h-72" initial={{
          scale: 1.08,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 0.85
        }} transition={{
          duration: 1.4,
          ease
        }} data-id="element-72" data-mp="1mojmem00btes" />
          <div className="absolute inset-0 mix-blend-color" style={{
          backgroundColor: need.accent,
          opacity: 0.22
        }} aria-hidden="true" data-id="element-73" data-mp="xzv4nxc71ylv" />
        </div>

        <p className="mt-8 text-lg font-light leading-relaxed text-enamel sm:text-xl" data-id="element-74" data-mp="16t86jos8kak3">
          {need.demand}
        </p>
        <p className="mt-5 text-base font-light leading-relaxed text-mute" data-id="element-75" data-mp="12so9el7nx6xy">{need.resolution}</p>

        <div className="mt-8 flex items-center gap-3" data-id="element-76" data-mp="f2ln6lqfiv79">
          <span className="label-mono text-[9px] text-mute/70" data-id="element-77" data-mp="a2z784j7v0ur">Technique</span>
          <span className="border px-3 py-1.5 text-sm font-light" style={{
          borderColor: `${need.accent}66`,
          color: need.accent
        }} data-id="element-78" data-mp="a527dhe32ad7">
            {need.technique}
          </span>
        </div>
      </div>

      <ProductPanel productId={need.productId} accent={need.accent} data-id="element-79" data-mp="1zgultuatt3ms" />
    </motion.div>;
}